import React, { lazy } from 'react'
import { Route } from 'react-router-dom'

import enhancePage from './enhancePage'
import { constants } from './constants'
import ProtectedRoute from './containers/ProtectedRoute'

/**
 * Warning: lazy takes a function that must call a dynamic import().
 * This must return a Promise which resolves to a module with a default export containing a React component.
 */

/* ADP Configurations API call is made from Layouts component */

const { routePaths } = constants

// const extractRouteProps = key => {
//     const { path, config_feature_key, permission } = routePaths[key]
//     return { path, permission, ...(config_feature_key ? { config_feature_key } : null) }
// }

const DashboardPage = enhancePage(lazy(() => import('./pages/Dashboard')))
const StoresPage = enhancePage(lazy(() => import('./containers/Stores')))
const StoreDetailsPage = enhancePage(lazy(() => import('./containers/StoreDetails')))
const OrdersPage = enhancePage(lazy(() => import('./containers/Orders')))
const OrderDetailsPage = enhancePage(
    lazy(() => import('./components/Orders/OrderDetails/OrderDetails'))
)

const PromotionsPage = enhancePage(lazy(() => import('./containers/Promotions')))
const PromoDetailPage = enhancePage(lazy(() => import('./containers/PromoDetail')))
const MarketingPage = enhancePage(lazy(() => import('./containers/Marketing')))
const PrioritizePromosPage = enhancePage(lazy(() => import('./containers/PrioritizePromos')))

const PushNotificationsPage = enhancePage(lazy(() => import('./containers/PushNotifications')))
const PushNotificationDetailsPage = enhancePage(
    lazy(() => import('./containers/PushNotificationDetails'))
)

const ManageStoresImportsPage = enhancePage(lazy(() => import('./pages/ManageStoresImports')))
const StoreImportManagePage = enhancePage(lazy(() => import('./pages/StoreImport')))
const StoreImportAddPage = enhancePage(lazy(() => import('./pages/StoreImport')))
const ManageProductsImportsPage = enhancePage(lazy(() => import('./pages/ManageProductsImports')))
const ProductImportManagePage = enhancePage(lazy(() => import('./pages/ProductImport')))
const ProductImportAddPage = enhancePage(lazy(() => import('./pages/ProductImport')))
const ManageInventoryImportsPage = enhancePage(lazy(() => import('./pages/ManageInventoryImports')))
const ManageNutritionImportsPage = enhancePage(lazy(() => import('./pages/ManageNutritionImports')))
const InventoryImportManagePage = enhancePage(lazy(() => import('./pages/InventoryImport')))
const InventoryImportAddPage = enhancePage(lazy(() => import('./pages/InventoryImport')))

const ManageProductsPage = enhancePage(lazy(() => import('./containers/ManageProducts')))
const ProductDetailsPage = enhancePage(lazy(() => import('./containers/ProductDetails')))
const ManageUpdatesPage = enhancePage(lazy(() => import('./containers/ManageUpdates')))
const AddNewProductsPage = enhancePage(lazy(() => import('./containers/AddNewProducts')))

const pages = [
    // DASHBOARD
    {
        path: routePaths.dashboard.path,
        element: DashboardPage,
        permission: routePaths.dashboard.permission,
        config_feature_key: routePaths.dashboard.config_feature_key,
    },

    // OPS TOOLS
    {
        path: routePaths.stores.path,
        element: StoresPage,
        permission: routePaths.stores.permission,
        config_feature_key: routePaths.stores.config_feature_key,
    },
    {
        path: routePaths.store_details.path,
        element: StoreDetailsPage,
        permission: routePaths.store_details.permission,
        config_feature_key: routePaths.store_details.config_feature_key,
    },
    {
        path: routePaths.orders.path,
        element: OrdersPage,
        permission: routePaths.orders.permission,
        config_feature_key: routePaths.orders.config_feature_key,
    },
    {
        path: routePaths.order_details.path,
        element: OrderDetailsPage,
        permission: routePaths.order_details.permission,
        config_feature_key: routePaths.order_details.config_feature_key,
    },

    // PROMOTIONS
    {
        path: routePaths.promotions.path,
        element: PromotionsPage,
        permission: routePaths.promotions.permission,
        config_feature_key: routePaths.promotions.config_feature_key,
    },
    {
        path: routePaths.promo_details.path,
        element: PromoDetailPage,
        permission: routePaths.promo_details.permission,
        config_feature_key: routePaths.promo_details.config_feature_key,
    },
    {
        path: routePaths.marketing.path,
        element: MarketingPage,
        permission: routePaths.marketing.permission,
        config_feature_key: routePaths.marketing.config_feature_key,
    },
    {
        path: routePaths.prioritize_promos.path,
        element: PrioritizePromosPage,
        permission: routePaths.prioritize_promos.permission,
        config_feature_key: routePaths.prioritize_promos.config_feature_key,
    },

    // PUSH NOTIFICATIONS
    {
        path: routePaths.push_notifications.path,
        element: PushNotificationsPage,
        permission: routePaths.push_notifications.permission,
        config_feature_key: routePaths.push_notifications.config_feature_key,
    },
    {
        path: routePaths.push_notification_details.path,
        element: PushNotificationDetailsPage,
        permission: routePaths.push_notification_details.permission,
        config_feature_key: routePaths.push_notification_details.config_feature_key,
    },

    // DATA MANAGEMENT
    {
        path: routePaths.manage_stores_imports.path,
        element: ManageStoresImportsPage,
        permission: routePaths.manage_stores_imports.permission,
        config_feature_key: routePaths.manage_stores_imports.config_feature_key,
    },
    {
        path: routePaths.manage_store_import.path,
        element: StoreImportManagePage,
        permission: routePaths.manage_store_import.permission,
        config_feature_key: routePaths.manage_store_import.config_feature_key,
    },
    {
        path: routePaths.add_new_store_import.path,
        element: StoreImportAddPage,
        permission: routePaths.add_new_store_import.permission,
        config_feature_key: routePaths.add_new_store_import.config_feature_key,
    },
    {
        path: routePaths.manage_products_imports.path,
        element: ManageProductsImportsPage,
        permission: routePaths.manage_products_imports.permission,
        config_feature_key: routePaths.manage_products_imports.config_feature_key,
    },
    {
        path: routePaths.manage_product_import.path,
        element: ProductImportManagePage,
        permission: routePaths.manage_product_import.permission,
        config_feature_key: routePaths.manage_product_import.config_feature_key,
    },
    {
        path: routePaths.add_new_product_import.path,
        element: ProductImportAddPage,
        permission: routePaths.add_new_product_import.permission,
        config_feature_key: routePaths.add_new_product_import.config_feature_key,
    },
    {
        path: routePaths.manage_inventory_imports.path,
        element: ManageInventoryImportsPage,
        permission: routePaths.manage_inventory_imports.permission,
        config_feature_key: routePaths.manage_inventory_imports.config_feature_key,
    },
    {
        path: routePaths.manage_nutrition_imports.path,
        element: ManageNutritionImportsPage,
        permission: routePaths.manage_nutrition_imports.permission,
        config_feature_key: routePaths.manage_nutrition_imports.config_feature_key,
    },
    {
        path: routePaths.manage_inventory_import.path,
        element: InventoryImportManagePage,
        permission: routePaths.manage_inventory_import.permission,
        config_feature_key: routePaths.manage_inventory_import.config_feature_key,
    },
    {
        path: routePaths.add_new_inventory_import.path,
        element: InventoryImportAddPage,
        permission: routePaths.add_new_inventory_import.permission,
        config_feature_key: routePaths.add_new_inventory_import.config_feature_key,
    },

    // ASSORTMENT
    {
        path: routePaths.products.path,
        element: ManageProductsPage,
        permission: routePaths.products.permission,
        config_feature_key: routePaths.products.config_feature_key,
    },
    {
        path: routePaths.products_product_details.path,
        element: ProductDetailsPage,
        permission: routePaths.product_details.permission,
        config_feature_key: constants.configFeatureFlags.ASSORTMENT,
    },
    {
        path: routePaths.manage_update_product_details.path,
        element: ProductDetailsPage,
        permission: routePaths.product_details.permission,
        config_feature_key: constants.configFeatureFlags.ASSORTMENT,
    },
    {
        path: routePaths.product_details.path,
        element: ProductDetailsPage,
        permission: routePaths.product_details.permission,
        config_feature_key: constants.configFeatureFlags.ASSORTMENT,
    },
    {
        path: routePaths.manage_updates.path,
        element: ManageUpdatesPage,
        permission: routePaths.manage_updates.permission,
        config_feature_key: routePaths.manage_updates.config_feature_key,
    },
    {
        path: routePaths.add_new_products.path,
        element: AddNewProductsPage,
        permission: routePaths.add_new_products.permission,
        config_feature_key: routePaths.add_new_products.config_feature_key,
    },

    // DEFAULT
    {
        path: '/',
        element: DashboardPage,
        permission: routePaths.dashboard.permission,
    },
]

const RoutesConfig = () => (
    <>
        {pages.map((page, i) => {
            const Element = page.element
            return (
                <Route
                    key={i}
                    path={page.path}
                    element={
                        <ProtectedRoute
                            permission={page.permission}
                            config_feature_key={page.config_feature_key}
                        >
                            <Element />
                        </ProtectedRoute>
                    }
                />
            )
        })}
    </>
)

export default RoutesConfig
